import { z } from 'zod';

export enum DealsSearchKey {
  DEAL_GROUP = 'dealGroupFilter',
}

export const dealsRouterSearchParamsSchema = z.object({
  [DealsSearchKey.DEAL_GROUP]: z.string().optional(),
});
